import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import "./auth.css";
import AuthService from "../../services/auth.service";

const Reset = ({ handleChange }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [userInput, setUserInput] = useState("");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);

		if (userInput === "") {
			return toast.error("Username or Email is required");
		}

		await AuthService.reset(userInput);

		setIsLoading(false);
	};

	return (
		<div className="auth__form__container">
			<h2 className="auth-heading">Enter Email or Staff ID to reset password</h2>
			<Form className="mt-5">
				<Form.Group className="mb-4" controlId="formBasicEmail">
					<Form.Control
						className="form__input form__input__field"
						type="text"
						placeholder="Enter staff ID or email"
						value={userInput}
						onChange={(e) => setUserInput(e.target.value)}
					/>
				</Form.Group>

				<div className="d-grid gap-2 pt-5">
					<Button
						className="auth__form__button form__input"
						size="lg"
						disabled={isLoading}
						onClick={handleSubmit}
					>
						{isLoading && <span className="spinner-border spinner-border-sm"></span>}
						<span>Reset</span>
					</Button>
				</div>
			</Form>
			<p>
				<span className="form__click__text" onClick={handleChange}>
					{" "}
					Click to sign in
				</span>
			</p>
		</div>
	);
};

export default Reset;
